export default __webpack_public_path__ + "static/media/button-small@2x.8d1c51cb.png";